export default __webpack_public_path__ + "static/media/squareMeters.3de42891.svg";